import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { INDEX_URL } from '../utils/constants';

const PrivateRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to={`${INDEX_URL}`} replace />;
  }

  return children ? children : <Outlet />;
};

export default PrivateRoute;